/**
 * Generation ID Manager
 * 
 * Manages generation_id for a single meal set generation attempt.
 * Created on "Meal Set Requested", used until generation completes or fails.
 */

import { STORAGE_KEYS } from './constants';

/**
 * Generate a UUID v4
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

// In-memory storage for current generation
let currentGenerationId = null;

/**
 * Create a new generation_id
 * Call this when "Create Meals" is clicked
 * @returns {string}
 */
export function createGenerationId() {
  currentGenerationId = generateUUID();
  try {
    sessionStorage.setItem(STORAGE_KEYS.GENERATION_ID, currentGenerationId);
  } catch (e) {
    console.warn('[Analytics] Error saving generation_id:', e);
  }
  return currentGenerationId;
}

/**
 * Get current generation_id
 * @returns {string|null}
 */
export function getGenerationId() {
  if (currentGenerationId) {
    return currentGenerationId;
  }
  
  try {
    const stored = sessionStorage.getItem(STORAGE_KEYS.GENERATION_ID);
    if (stored) {
      currentGenerationId = stored;
      return stored;
    }
  } catch (e) {
    console.warn('[Analytics] Error reading generation_id:', e);
  }
  
  return null;
}

/**
 * Clear generation_id
 * Call this when starting a completely new flow
 */
export function clearGenerationId() {
  currentGenerationId = null;
  try {
    sessionStorage.removeItem(STORAGE_KEYS.GENERATION_ID);
  } catch (e) {
    console.warn('[Analytics] Error clearing generation_id:', e);
  }
}
